let ErrorHandler = {
    install(Vue, options) {
        Vue.prototype.$errors = {
            set(keys, error) {
                if (this.hasResponse(error)) {
                    if (this.responseHasErrors(error)) {
                        let errors = error.response.data['errors'];
                        for (let key in keys) {
                            keys[key] = errors[key]
                                ? errors[key][0]
                                : '';
                        }
                    } else {
                        this.clear(keys);
                    }

                    return error.response.data.message
                        ? error.response.data.message
                        : `${error.response.status}: ${error.response.statusText}`;
                } else {
                    this.clear(keys);
                    return error;
                }
            },

            clear(keys) {
                for (let key in keys) {
                    keys[key] = '';
                }
            },

            hasResponse(error) {
                return error.response;
            },

            responseHasErrors(error) {
                return error.response.data['errors'];
            }
        };
    }
};

export default ErrorHandler;
